/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Summary_Reasoning_Present_1Inputs */



/**
* | output |
* | --- |
* | "thinking it through" |
*
* @param {Chat_Summary_Reasoning_Present_1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_summary_reasoning_present_1 = /** @type {((inputs?: Chat_Summary_Reasoning_Present_1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Summary_Reasoning_Present_1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("denke nach")
	return /** @type {LocalizedString} */ ("thinking it through")
});